<template>
  <ZMainPage type="card" :loading="pageLoading">
    <div class="z-box-bg top-info mb-3">
      <div class="top-info-item" v-for="item in list0" :key="item.label">
        <div class="top-info-label">{{ item.label }}</div>
        <div class="top-info-value">
          <span :class="item.class">{{ item.value }}</span>
          <span class="text-primary ml-2 c-p" v-if="item.button" @click="handleView(item.type)">{{ item.button }}</span>
        </div>
      </div>
    </div>
    <div class="bg-white mt-2">
      <Tabs :index.sync="index" :list="labelList" :cssStyle="{ fontSize: '20rem', padding: '0 20rem' }"></Tabs>
    </div>
    <div class="z-box-bg" v-if="index === 0">
      <LineWrapper class="list1" label-width="130rem">
        <LineItem :label="item.label" v-for="item in list1" :key="item.label">
          <span class="mr-2" v-if="item.value !== ''">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handleView(item.type)">{{ item.button }}</span>
        </LineItem>
      </LineWrapper>
    </div>
    <div v-else-if="index === 1">
      <div class="z-box-bg">
        <LineWrapper class="list1" label-width="130rem">
          <LineItem :label="item.label" v-for="item in list2" :key="item.label">
            <span class="mr-2" v-if="item.value !== ''">{{ item.value }}</span>
            <span class="text-primary c-p" v-if="item.button" @click="handleView(item.type)">{{ item.button }}</span>
          </LineItem>
        </LineWrapper>
      </div>
      <div class="mt-2">
        <div class="text-primary page-title">中考考试成绩</div>
        <div class="z-box-bg">
          <DetailTable border :data="tableData2" :config="tableConfig2"></DetailTable>
        </div>
      </div>
      <div class="mt-2">
        <div class="text-primary page-title">诊断性考试成绩</div>
        <div class="z-box-bg">
          <DetailTable :data="tableData3" :config="tableConfig3"></DetailTable>
        </div>
      </div>
    </div>
    <div class="z-box-bg" v-else-if="index === 2 && labelList.length === 4">
      <div style="border-bottom: 1px dashed #598BFF;margin-bottom: 30rem;">
        <LineWrapper list min="280">
          <LineItem :label="item.label" :value="item.value" v-for="item in list3" :key="item.label">
          </LineItem>
        </LineWrapper>
      </div>
      <CustomTable :data="tableData4" :config="tableConfig4" />
    </div>
    <div class="z-box-bg" v-else-if="(index === 3 && labelList.length === 4) || (index === 2 && labelList.length === 3)">
      <template v-if="list4.length">
        <div class="list2" v-for="item in list4" :key="item.id">
          <div class="title">{{ item.label }}</div>
          <div class="content">{{ item.value }}</div>
        </div>
      </template>
      <t-result type='empty' v-else></t-result>
    </div>
    <Dialog :visible.sync="visible" :title="dynamicTitle" :size="dynamicSize" :loading="loading" submitText="我知道了" titleAlign="center" buttonAlign="center" :showCancelButton="false" :showClose="false" :closeOnClickModal="false">
      <template v-if="dynamicType === 1">
        <LineWrapper label-width="100rem" class="flex flex-column align-center" labelColor="#3c3c3c" :valueStyle="{fontWeight: 600}">
          <LineItem :label="item.label" :value="item.value" v-for="item in dialogList1" :key="item.label" style="width: 300rem;"></LineItem>
        </LineWrapper>
      </template>
      <template v-else-if="dynamicType === 2">
        <DetailTable border :data="tableData1" :config="tableConfig1"></DetailTable>
      </template>
      <template v-else-if="dynamicType === 3">
        <el-image :src="dialogSrc" lazy></el-image>
      </template>
      <template v-else-if="dynamicType === 0">
        <template v-if="dialogList2.length">
          <div class="my-1" v-for="item in dialogList2">
            <el-link type="primary" :href="item.other_url" target="_blank">{{ item.service_name }}-{{ item.contract_type === 5 ? item.bb_agreement_sn : item.agreement_sn }}</el-link>
          </div>
        </template>
        <div class="t-c pt-3 pb-2 text-muted" v-else>暂无数据</div>
      </template>
    </Dialog>
    <template #footer>
      <el-button type="primary" @click="$router.back()">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import Dialog from "@/components/common/Dialog"
import Tabs from "@/components/common/Tabs"
import LineWrapper from "@/components/common/LineWrapper"
import LineItem from "@/components/common/LineItem"
import DetailTable from "@/components/common/DetailTable"
import CustomTable from "@/components/common/CustomTable"
import { zsGet } from '@/api'
import { orderStatusColor } from '@/utils/data'
export default {
	_config:{"route":{"path":"detail","meta":{"title":"详情"}}},
  components: { Dialog, Tabs, LineWrapper, LineItem, DetailTable, CustomTable },
  data() {
    return {
      visible: false,
      pageLoading: false,
      loading: false,
      dynamicTitle: '',
      dynamicSize: '',
      dynamicType: '',
      index: 0,
      labelList: [],
      list0: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      tableData1: [],
      tableConfig1: [],
      tableData2: [],
      tableConfig2: [],
      tableData3: [],
      tableConfig3: [],
      tableData4: [],
      tableConfig4: [],
      dialogSrc: '',
      dialogLoaded: false,
      dialogList1: [],
      dialogList2: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageLoading = true
      zsGet('/recruit/fresh-graduate/details-v2', { order_id: this.$route.query.id }).then(res => {
        // 顶部展示
        const { student_health: { crime_text, physiology, psychology }, regist_info: info, senior_score: score, service_notice: notice, remark_list = [], diff_fee_status_name, stages, stages_v2 } = res
        this.list0 = [
          { label: '订单状态', value: res.order_status, class: orderStatusColor[res.order_status] },
          { label: '学生姓名', value: res.student_name },
          { label: '性别', value: res.sex },
          { label: '家长姓名', value: res.parent_name },
          { label: '家长和学生的关系', value: res.relationship_name },
          { label: '是否可招收', value: res.recruit, button: `${res.recruit === '可招收' ? '查看详情' : ''}`, type: 1 },
        ]
        this.dialogList1 = [
          { label: '身体疾病', value: physiology },
          { label: '心理疾病', value: psychology },
          { label: '犯罪记录', value: crime_text },
        ]
        // 报名信息
        const list1 = [
        { label: '报名就读学校', value: info.school },
          { label: '实际就读学校', value: info.reality_school },
          { label: '学籍所属学校', value: info.belong_school },
          { label: '高中学习方向', value: info.study_type_name || '-' },
          { label: '高中专业方向', value: info.major_name || '-' },
          { label: '学生户籍地', value: info.student_register_address_name || '-' },
          { label: '学生当前状态', value: info.student_status },
          { label: '所属业务线', value: info.business_type || '普通生' },
          { label: '报名年级', value: info.grade_name },
          { label: '所参与优惠政策', value: info.deduction_type_name },
          { label: '是否参加预报名', value: info.is_pre_register, button: `${info.is_pre_register === '是' ? '查看详情' : ''}`, type: 2 },
          { label: '订单号', value: info.order_number },
          { label: '创建订单时间', value: info.order_created_at },
          { label: '系统计算应缴总额', value: info.money_answer },
          { label: '实际应缴总额', value: info.money_answer_actual_total },
          { label: '实际支付总额', value: info.money_actual },
          { label: '特批优惠总额', value: info.money_offline_discount }
        ]
        if (Number(info.money_not_paid)) {
          list1.push({ label: '欠缴总额', value: info.money_not_paid })
        }
        const list1_2 = [
          { label: '报名手机号', value: info.account_mobile },
          { label: '支付订单号', value: info.payment_number || '-' },
          { label: '支付成功时间', value: info.pay_time || '-' },
          { label: '当前客户归属人', value: info.belong_teacher || '-' },
          { label: '报名招生老师', value: info.sign_teacher || '-'  },
          { label: '是否参与保本协议', value: info.is_baoben_name  },
          { label: '签约时间', value: info.sign_time || '-' },
          { label: '协议编号', value: '', button: '查看', type: 0 },
          { label: '签约手机号', value: info.sign_phone }
        ]
        this.list1 = [...list1, ...list1_2]
        // 预报名列表
        this.tableConfig1 = [
          { prop: 'order_number', label: '预报名订单号' },
          { prop: 'belong_teacher_name', label: '预报名客户归属人' },
          { prop: 'money_answer', label: '应缴金额' },
          { prop: 'money_actual', label: '实缴金额' },
          { prop: 'pay_time', label: '支付时间' }
        ]
        this.tableData1 = info.pre_register
        // 学生中考成绩
        this.list2 = [
          { label: '参加中考城市', value: score.senior_city },
          { label: '中考报名号', value: score.application_no || '-' },
          { label: '中考准考证号', value: score.admission_ticket_no || '-' },
          { label: '中考成绩证明图', value: score.score_image ? '' : '-',  button: `${score.score_image ? '查看详情' : ''}`, type: 3 },
          { label: '判定最高成绩考试', value: score.max_score_name },
          { label: '判定最高成绩总分', value: score.max_score_total },
          { label: '初中毕业学校', value: score.student_attend_graduation_school || '-' },
        ]
        // 中考考试成绩
        const { junior_score = [], diagnose_score = [] } = score
        this.tableConfig2 = junior_score.map(i => ({ label: i.subject_name, prop: 'prop' + i.subject_id }))
        let obj = {}
        junior_score.map(i => {
          const { subject_level = {}, subject_id } = i
          obj['prop' + subject_id] = subject_level.level || subject_level.score
        })
        this.tableData2 = [obj]
        this.dialogSrc = score.score_image
        // 备注信息
        this.list4 = remark_list.map(i => ({ id: i.id, label: `${i.creator} 在 ${i.created_at} 提交了备注`, value: i.content }))

        // 学生缴费情况
        if (res.year >= 2026 && res.order_type === 2) {
          const { stages_options } = stages_v2
          if (stages_options.length) {
            this.labelList = ['报名信息', '学生中考成绩', '学生缴费情况', '备注信息']
            const cf = [
              { prop: 'left', label: ['缴费状态', '缴费计划'], type: 'custom' }
            ]
            stages_options.forEach((i, j) => {
              cf.push({ prop: 'period' + j, label: i.goods_category_name, type: 'other' })
            })
            const arr0 = [{ label: '应缴金额', key: 'compute_price' }, { label: '已缴金额', key: 'paid_price' }, { label: '合计欠缴', key: 'to_pay_price' }]
            const arr1 = arr0.map((i) => {
              const obj = {}
              stages_options.map((k, l) => {
                obj['period' + l] =  k[i.key]
              })
              return { left: i.label, ...obj }
            })
            this.tableConfig4 = cf
            this.tableData4 = [...arr1]
            this.list3 = [
              { label: '实际应缴总额', value: stages_v2.compute_price_total },
              { label: '实际支付总额', value: stages_v2.paid_price_total },
              { label: '欠缴总额', value: stages_v2.to_pay_price_total }
            ]
          } else {
            this.labelList = ['报名信息', '学生中考成绩', '备注信息']
          }
        } else {
          const { detail } = stages
          if (detail.length) {
            this.labelList = ['报名信息', '学生中考成绩', '学生缴费情况', '备注信息']
            const cf = [
              { prop: 'left', label: ['缴费状态', '缴费计划'], type: 'custom' }
            ]
            detail[0].forEach((i, j) => {
              cf.push({ prop: 'period' + j, label: i, type: 'other' })
            })
            cf.push({ prop: 'compute_price', label: '合计', type: 'other' })
            const len = detail[0].length
            const arr1 = detail[1].map(i => {
              let obj = { left: i.goods_category_name_show }
              for (let j = 0; j < len; j++) {
                obj['period' + j] = i.child[j]?.answer_price || '-'
              }
              obj.compute_price = i.total
              return obj
            })
            const arr0 = [{ label: '已缴金额' }, { label: '合计欠缴' }]
            const arr2 = arr0.map((i, j) => {
              const obj = {}
              detail[2].map((k, l) => {
                obj['period' + l] = j ? k.have_not_paid : k.total_price
              })
              if (j) {
                obj.compute_price = stages.money_not_paid
              } else {
                obj.compute_price = stages.total_price
              }
              return { left: i.label, ...obj }
            })
            this.tableConfig4 = cf
            this.tableData4 = [...arr1, ...arr2]
            this.list3 = [
              { label: '实际应缴总额', value: stages.money_answer },
              { label: '实际支付总额', value: stages.money_actual },
              { label: '欠缴总额', value: stages.money_not_paid }
            ]
            // 隐藏
            // if (stages.is_by_stages === 1) {
            //   this.list3.splice(1, 0, { label: '一期实缴金额', value: stages.first_money_actual },)
            // }
          } else {
            this.labelList = ['报名信息', '学生中考成绩', '备注信息']
          }
        }
        

        // 诊断性考试成绩
        if (diagnose_score.length) {
          this.tableConfig3 = diagnose_score.shift().map((i, j) => ({ label: i, prop: 'prop' + j }))
          this.tableData3 = diagnose_score.map((i, j) => {
            let obj = {}
            for (const key in i) {
              obj['prop' + key] = i[key] || 0
            }
            return obj
          })
        }
      }).finally(() => this.pageLoading = false)

    },
    handleView(idx) {
      if(!idx && !this.dialogLoaded) {
        this.loading = true
        zsGet('/recruit/fresh-graduate/contract', { order_id: this.$route.query.id }).then(res => {
          this.dialogList2 = res
          this.dialogLoaded = true
        }).finally(() => this.loading = false)
      }
      const titleArr = ['查看协议', '学生身心情况', '预报名订单', '中考成绩证明']
      this.visible = true
      this.dynamicType = idx
      this.dynamicSize = idx === 2 ? 'big' : 'small'
      this.dynamicTitle = titleArr[idx] || ''
    },
  }
}
</script>

<style lang="scss" scoped>
.top-info {
  display: flex;
  flex-wrap: wrap;
  gap: 20rem;
  &-item {
    max-width: 240rem;
    margin-right: 80rem;
    font-size: 15rem;
    line-height: 32rem;
    display: flex;
    flex-shrink: 0;
  }
  &-label {
    margin-right: 30rem;
  }
  &-value {
    font-weight: 600;
  }
}
.list1 {
  display: grid;
  gap: 10rem 20rem;
  grid-template-columns: repeat(auto-fill, minmax(380rem, 1fr));
}
.list2 {
  .title {
    font-size: 18rem;
    margin-bottom: 16rem;
  }
  .content {
    min-height: 100rem;
    margin-bottom: 30rem;
    padding: 18rem 16rem;
    font-size: 16rem;
    color: #888;
    border-radius: 8rem;
    background-color: #FBFCFC;
  }
}
.page-title {
  padding-left: 20rem;
  margin-bottom: 10rem;
  font-size: 20rem;
  font-weight: 600;
  line-height: 1.8;
}
</style>
